<template>
<section class="w1312 main-content-wrap">
  <section class="course-container clearfix">
    <div class="lefter-container">
      <ul>
        <li @click="goCourse(item)">
          <dl class="clearfix">
            <dt></dt>
            <dd>
              <span>课程</span>
              <br/>
              {{courseDetail.title}}
            </dd>
          </dl>
        </li>
        <li v-for="(item, index) in (courseDetail && courseDetail.chapterOverviews || [])" :key="index" :class="{'active': item.chapterId === chapterDetail.chapterId}" @click="goChapter(item) & $send('vschool_courselanding_chapter_buttonclick', {'sessionTarget': sessionTarget, 'chapter': item.title, 'courseId': courseId, 'chapterId': item.chapterId })">
          <dl class="clearfix">
            <dt></dt>
            <dd>
              <span>
                <i :class="{'c-finish': true}" v-if="item.studied === 1">(已完成)</i>
                <i :class="{'c-unfinish': true}" v-if="item.studied === 0">(待完成)</i>
                章节{{index + 1}}
              </span>
              <br/>
              {{item.title}}
            </dd>
          </dl>
        </li>
        <!--lastExamResult 上次考试结果，0-未考过、1-及格、2-不及格 -->
        <li v-for="(item, index) in (examOfCourseList || [])" :key="index">
          <dl class="clearfix">
            <dt></dt>
            <dd class="exam-list">
              <template v-if="item.times === 1">
                <a :href="item.examUrl" class="button" target="_blank" title="开始答题" v-if="!deadlineTimeout(item.deadline) &&item.examUrl && item.lastExamResult === 0">
                  <span>
                    <i :class="{'c-finish': true}" v-if="item.lastExamResult === 1">(已完成)</i>
                    <i :class="{'c-unfinish': true}" v-else>(待完成)</i>
                    考试{{examOfCourseList.length > 1 ? index + 1 : ''}}
                  </span>
                  <br/>
                  {{item.title}}
                </a>
                <a :href="item.analysisUrl" class="button info" target="_blank" title="答题解析" v-if="item.analysisUrl && (item.lastExamResult === 2 || item.lastExamResult === 1 || deadlineTimeout(item.deadline))">
                  <span>
                    <i :class="{'c-finish': true}" v-if="item.lastExamResult === 1">(已完成)</i>
                    <i :class="{'c-unfinish': true}" v-else>(待完成)</i>
                    考试{{examOfCourseList.length > 1 ? index + 1 : ''}}
                  </span>
                  <br/>
                  {{item.title}}
                </a>
              </template>
              <template v-else-if="item.times === 999">
                <a :href="item.examUrl" class="button" target="_blank" title="开始答题" v-if="!deadlineTimeout(item.deadline) && item.examUrl && item.lastExamResult === 0">
                  <span>
                    <i :class="{'c-finish': true}" v-if="item.lastExamResult === 1">(已完成)</i>
                    <i :class="{'c-unfinish': true}" v-else>(待完成)</i>
                    考试{{examOfCourseList.length > 1 ? index + 1 : ''}}
                  </span>
                  <br/>
                  {{item.title}}
                </a>
                <a :href="item.analysisUrl" class="button" target="_blank" title="答题解析" v-if="item.analysisUrl && (item.lastExamResult !== 0 || deadlineTimeout(item.deadline))">
                  <span>
                    <i :class="{'c-finish': true}" v-if="item.lastExamResult === 1">(已完成)</i>
                    <i :class="{'c-unfinish': true}" v-else>(待完成)</i>
                    考试{{examOfCourseList.length > 1 ? index + 1 : ''}}
                  </span>
                  <br/>
                  {{item.title}}
                </a>
              </template>
              <template v-else>
                <template v-if="!deadlineTimeout(item.deadline) && (item.lastExamResult === 0 || (item.lastExamResult === 2 && item.makeupCount))">
                  <a :href="item.examUrl" class="button" target="_blank" title="开始答题" v-if="item.examUrl">
                    <span>
                      <i :class="{'c-finish': true}" v-if="item.lastExamResult === 1">(已完成)</i>
                      <i :class="{'c-unfinish': true}" v-else>(待完成)</i>
                      考试{{examOfCourseList.length > 1 ? index + 1 : ''}}
                    </span>
                    <br/>
                    {{item.title}}
                  </a>
                </template>
                <template v-else>
                  <a :href="item.analysisUrl" class="button info" target="_blank" title="答题解析" v-if="item.analysisUrl && (item.lastExamResult === 2 || item.lastExamResult === 1)">
                    <span>
                      <i :class="{'c-finish': true}" v-if="item.lastExamResult === 1">(已完成)</i>
                      <i :class="{'c-unfinish': true}" v-else>(待完成)</i>
                      考试{{examOfCourseList.length > 1 ? index + 1 : ''}}
                    </span>
                    <br/>
                    {{item.title}}
                  </a>
                </template>
              </template>
            </dd>
          </dl>
        </li>
      </ul>
    </div>
    <div class="righter-container">
      <view-container :loading="loading" :empty="empty" :error="error" @retry="loadData">
        <div class="right-content">
          <div class="bread-crumb">
            <a href="javascript:;" @click="goBack()" class="c-666">返回</a>
            &gt;
            {{courseDetail.title}}
          </div>
          <div class="notice-wrap">
            <div class="chapter-title clearfix">
              {{chapterDetail.title}}
              <p class="chapter-down">
                <a href="javascript:;" title="下载" @click="download(chapterDetail.courseware && chapterDetail.courseware.url)">
                  <i class="down-icon"></i>
                  下载
                </a>
              </p>
            </div>
          </div>
          <div class="notice-wrap">
            <template v-if="chapterDetail.coursewareType === 'TEXT'">
              <!-- <iframe width="100%" style="border: none;" id="frame" onload="this.height=this.contentWindow.document.body.scrollHeight" :src="`data:text/html;charset=UTF-8,${encodeURIComponent(chapterDetail && chapterDetail.textModel && chapterDetail.textModel.richText || '')}`">
              </iframe> -->
              <!-- <div class="info" v-html="chapterDetail && chapterDetail.textModel && chapterDetail.textModel.richText"></div> -->
              <div class="info">
                <div class="text-center" style="min-height: 100px; padding-top: 80px;" v-show="textLoaing">
                  <div class="text-loading">
                    加载中...
                  </div>
                </div>
                <iframe
                  width="100%"
                  style="border: none; height: 100%;"
                  id="richTextFrame"
                  v-show="!textLoaing"
                  :src="`data:text/html;charset=UTF-8,${encodeURIComponent(generateIframeContent(chapterDetail && chapterDetail.textModel && chapterDetail.textModel.richText || ''))}`">
                </iframe>
              </div>
            </template>
            <template v-else-if="chapterDetail.coursewareType === 'IMAGE'">
              <div class="text-center">
                <img v-for="(item, index) in (chapterDetail && chapterDetail.imageModel && chapterDetail.imageModel.imageUrls || [])" :src="item" :key="index"/>
              </div>
            </template>
            <template v-else-if="chapterDetail.coursewareType === 'VIDEO'">
              <div class="text-center">
                <video id="video" controls :src="chapterDetail.videoModel.videoUrl"/>
              </div>
            </template>
            <div class="notice-wrap course-content text-right" v-if="courseDetail.attachment && courseDetail.attachment.url">
              点击下载附件1：<a href="javascript:;" @click="downloadAttachment(courseDetail.attachment.url)" mars_sead="vschool_courselanding_attachmentdownload_download" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'courseId': courseId})">{{courseDetail.attachment.filename}}</a>
            </div>
            <div class="chapter-switch clearfix">
              <div class="chapter-prev" v-if="prevChapter" @click="goChapter(prevChapter) & $send('vschool_courselanding_chapter_buttonclick', {'sessionTarget': sessionTarget, 'chapter': prevChapter.title, 'courseId': courseId, 'chapterId': prevChapter.chapterId })">
                上一章节：<a href="javascript:;">{{prevChapter.title}}</a>
              </div>
              <div class="chapter-next" v-if="nextChapter" @click="goChapter(nextChapter) & $send('vschool_courselanding_chapter_buttonclick', {'sessionTarget': sessionTarget, 'chapter': nextChapter.title, 'courseId': courseId, 'chapterId': nextChapter.chapterId })">
                下一章节：<a href="javascript:;">{{nextChapter.title}}</a>
              </div>
            </div>
          </div>
        </div>
      </view-container>
    </div>
    <t-space class="affix" :class="{'affix-switch': true}">
      <t-affix ref="affix" :offset-top="140" :offset-bottom="140" :onFixedChange="onFixedChange">
        <div class="affix-wrap" :class="{'iconfont-disable': !showAffix}" @click="showAffix && goTop()">
          <div>
            <i class="iconfont icon-rule-top affix-icon"></i>
            <p>顶部</p>
          </div>
        </div>
      </t-affix>
    </t-space>
  </section>
</section>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import $ from 'jquery'
import mixins from '../examCenter/mixins'
import {generateIframeContent} from '../../util/iframeHelper'
export default {
  name: '',
  mixins: [mixins],
  data () {
    return {
      courseId: '',
      chapterId: '',
      hadStudy: false,
      showAffix: false,
      loading: false,
      empty: false,
      error: false,
      iframeMessageListener: null,
      textLoaing: true
    }
  },
  computed: {
    ...mapState(['courseDetail', 'chapterDetail', 'userInfo', 'sessionTarget', 'queryUserPromise', 'examOfCourseList']),
    chapterOverviews () {
      return this.courseDetail && this.courseDetail.chapterOverviews || []
    },
    prevChapter () {
      let chapterIndex = this.chapterOverviews.findIndex((item) => item.chapterId === this.chapterId)
      if (chapterIndex > 0) {
        return this.chapterOverviews[chapterIndex - 1]
      } else{
        return null
      }
    },
    nextChapter () {
      let chapterIndex = this.chapterOverviews.findIndex((item) => item.chapterId === this.chapterId)
      if (chapterIndex < this.chapterOverviews.length) {
        return this.chapterOverviews[chapterIndex + 1]
      } else{
        return null
      }
    }
  },
  mounted () {
    let _this = this
    this.queryUserPromise.then(() => {
      this.loadData()
    })
    this.iframeMessageListener = (event) => {
      // 安全检查：确保消息来源可信（在生产环境应更严格）
      // if (event.origin !== window.location.origin) return;
      if (event.data && event.data.type === 'iframeHeight' && event.data.id === 'richTextFrame') {
        const iframe = document.getElementById('richTextFrame')
        if (iframe) {
          _this.textLoaing = false
          iframe.style.height = (36 + event.data.height) + 'px';
          // console.log('Iframe height set to:', event.data.height)
        }
      }
    };
    window.addEventListener('message', this.iframeMessageListener)
  },
  beforeUnmount() {
    if (this.iframeMessageListener) {
      window.removeEventListener('message', this.iframeMessageListener)
    }
  },
  methods: {
    loadData () {
      const {
        courseId,
        chapterId
      } = this.$route.params
      this.courseId = Number(courseId)
      this.chapterId = Number(chapterId)
      if (this.courseDetail.courseId !== this.courseId) {
        this.queryByCourseId(courseId)
        this.queryCourseDetail(courseId).then(() => {
          if (!this.courseDetail.privileged) {
            this.$message.warning('对不起，当前章节无权查看')
            this.$router.push({
              name: 'Index',
            })
          }
        })
      } else {
        this.queryCourseDetail(courseId)
        setTimeout(() => {
          this.updatePrimaryCategoryId(this.courseDetail.primaryCategoryId)
        }, 10)
      }
      let _this = this
      this.loading = true
      this.error = false
      this.queryChapter({
        courseId,
        chapterId
      }).then(() => {
        let onscrollFn = function(isVideo) {
          let top = document.documentElement.scrollTop||document.body.scrollTop
          let height = document.documentElement.offsetHeight || document.body.offsetHeight
          let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
          if (_this.chapterDetail && ((_this.chapterDetail.coursewareType !== 'VIDEO' && top + windowHeight + 300 >= height) || (_this.chapterDetail.coursewareType === 'VIDEO' && isVideo === true))) {
            if (!_this.hadStudy) {
              _this.userInfo && _this.userInfo.username && _this.studyChapter({
                courseId,
                chapterId,
                completed: 1 // 是否学习完成，0-学习中、1-学习完成
              })
            }
            _this.hadStudy = true
          }
          // console.log('滚动...', event, top, windowHeight, height)
        }
        window.onscroll = onscrollFn
        setTimeout(() => {
          let video = document.getElementById('video')
          video && video.addEventListener('play', () => {
            console.log('play')
            this.$send('vschool_courselanding_toggleplaybackstarttime_buttonclick', {'sessionTarget': this.sessionTarget, 'chapter': this.courseDetail.title, 'courseId': courseId, 'chapterId': chapterId })
          })
          video && video.addEventListener('ended', () => {
            console.log('ended')
            onscrollFn(true)
            this.$send('vschool_courselanding_toggleplaybackfinishtime_buttonclick', {'sessionTarget': this.sessionTarget, 'chapter': this.courseDetail.title, 'courseId': courseId, 'chapterId': chapterId })
          })
          onscrollFn()
        }, 400)
      }).catch(() => {
        this.error = true
      }).finally(() => {
        this.loading = false
        if (_this.chapterDetail.coursewareType === 'TEXT') {
          _this.textLoaing = true
        } else {
          _this.textLoaing = false
        }
      })
      this.userInfo && this.userInfo.username && this.studyChapter({
        courseId,
        chapterId,
        completed: 0 // 是否学习完成，0-学习中、1-学习完成
      })
    },
    goCourse () {
      this.$router.push({
        name: 'CourseDetail',
        params: {
          'courseId': this.courseDetail.courseId,
          'target': this.sessionTarget
        }
      })
    },
    goChapter (item) {
      this.$router.push({
        name: 'ChapterDetail',
        params: {
          'courseId': this.courseDetail.courseId,
          'chapterId': item.chapterId,
          'target': this.sessionTarget
        }
      })
    },
    goBack () {
      this.$router.go(-1)
    },
    download (url) {
      if (!url) {
        return this.$message.warning('下载链接异常，请联系管理员')
      }
      let $a = document.createElement('a');
        $a.setAttribute('href', url);
        // $a.setAttribute('download', `${this.title}-${this.moment(this.operationTimestamp)}.jpeg`);
        let fileLink = document.createElement('span')
        fileLink.setAttribute('style', 'cursor: pointer; -webkit-tap-highlight-color: transparent')
        $a.appendChild(fileLink)
        let body = document.getElementsByTagName('body')[0]
        body.appendChild($a)
        fileLink.click()
        body.removeChild($a)
    },
    onFixedChange () {
      // console.log(22, affixed, context, $(window).scrollTop())
      if ($(window).scrollTop() > 0) {
        this.showAffix = true
      } else {
        this.showAffix = false
      }
    },
    goTop () {
      // $(window).scrollTop(0)
      $("html, body").animate({
        scrollTop: 0
      }, 200)
    },
    downloadAttachment (url) {
      let $a = document.createElement('a')
      $a.setAttribute('href', url)
      $a.setAttribute('target', '_blank')
      // $a.setAttribute('download', `${this.title}-${this.moment(this.operationTimestamp)}.jpeg`);
      let fileLink = document.createElement('span')
      fileLink.setAttribute('style', 'cursor: pointer; -webkit-tap-highlight-color: transparent')
      $a.appendChild(fileLink)
      let body = document.getElementsByTagName('body')[0]
      body.appendChild($a)
      fileLink.click()
      body.removeChild($a)
    },
    generateIframeContent (richTextContent) {
      return generateIframeContent(richTextContent)
    },
    ...mapMutations(['updatePrimaryCategoryId']),
    ...mapActions(['queryCourseDetail', 'queryChapter', 'studyChapter', 'queryByCourseId'])
  }
}
</script>

<style lang="scss" scoped>
.bread-crumb {
  font-size: 16px;
  color: #999;
  padding: 20px 36px;
}
.notice-wrap {
  background: #fff;
  padding: 13px 36px;
  img, video {
    max-width: 906px;
  }
  /deep/ img, /deep/ video {
    max-width: 906px;
  }
  video {
    width: 100%;
  }
  .info {
    display: block;
    height: 100%;
  }
  .info {
    all:initial;
    word-wrap: break-word;
    white-space: normal;
    display: block;
    overflow: auto;
    .text-loading {
      display: inline-block;
      background: url(../../assets/img/loading.gif) no-repeat;
      background-size: 100%;
      width: 50px;
      height: 50px;
      margin-bottom: 5px;
      font-size: 12px;
      color: #999;
      padding-top: 55px;;
    }
    /deep/ p  {
      display: block;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
    }
    /deep/ ul {
      display: block;
      list-style-type: disc;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 40px;
    }
    /deep/ li {
      display: list-item;
      text-align: -webkit-match-parent;
    }
    /deep/ a:-webkit-any-link {
      color: -webkit-link;
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
.chapter-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  p {
    float: right;
    font-size: 16px;
    font-weight: normal;
    &.chapter-down {
      .down-icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url(../../assets/img/bg-down.png) no-repeat;
        background-size: 14px;
      }
    }
  }
}
.course-wrap {
  border-bottom: 1px solid #E7E7E7;
  padding-bottom: 50px;
  display: flex;
  .course-lefter {
    flex: 1;
    width: 505px;
    min-width: 505px;
    position: relative;
    .course-title {
      font-size: 24px;
      color: #333;
    }
    .course-desc {
      font-size: 16px;
      color: #666;
      margin-top: 12px;
    }
    .course-show {
      margin-top: 30px;
      .course-button {
        display: inline-block;
        background: #FD3374;
        width: 104px;
        height: 34px;
        border-radius: 20px;
        color: #fff;
        font-size: 14px;
        text-align: center;
        line-height: 34px;
      }
    }
    .like-container {
      position: absolute;
      bottom: 0;
      font-size: 14px;
      button {
        line-height: 30px;
        border: 1px solid #D3D6DA;
        margin-right: 22px;
        padding: 0 16px;
        border-radius: 30px;
        color: #666;
        cursor: pointer;
        outline: none;
        &.active {
          background: #FD3374;
          color: #fff;
        }
        &:first-child {
          i {
            display: inline-block;
            width: 16px;
            height: 16px;
            background: url(../../assets/img/happy-icon.png) no-repeat;
            vertical-align: middle;
            position: relative;
            top: -2px;
            margin-right: 5px;
          }
        }
        &:nth-child(2) {
          i {
            display: inline-block;
            width: 16px;
            height: 16px;
            background: url(../../assets/img/crying-icon.png) no-repeat;
            vertical-align: middle;
            position: relative;
            top: -2px;
            margin-right: 5px;
          }
        }
      }
    }
  }
  .course-righter  {
    flex: 1;
    width: 398px;
    max-width: 398px;
    height: 260px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 0 8px #f5f5f5;
    img {
    }
  }
}
.course-content {
  font-size: 16px;
  color: #333;
}
.course-container {
  margin-top: 25px;
  display: flex;
  .lefter-container {
    // float: left;
    flex: 1;
    width: 296px;
    max-width: 296px;
    background: #fff;
    border-radius: 8px;
    padding: 32px 32px;
    margin-bottom: 25px;
    .lefter-title {
      font-size: 18px;
      font-weight: bold;
      margin-top: 32px;
    }
    ul {
      li {
        font-size: 16px;
        position: relative;
        background: url(../../assets/img/line-bg.png) repeat-y 12px 0;
        line-height: 20px;
        padding-bottom: 65px;
        cursor: pointer;
        &:last-child {
          padding-bottom: 0;
          background: none;
        }
        &:hover {
          dl {
            dd {
              color: #FD3374;
            }
          }
        }
        .nav-icon {
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url(../../assets/img/nav-icon.png) no-repeat;
          margin-top: 5px;
        }
        .iconfont, /deep/ .iconfont {
          position: absolute;
          right: 0;
          top: 6px;
          z-index: 1;
        }
        &:first-child {
          dl {
            dt {
              background: url(../../assets/img/book-icon.png) no-repeat;
            }
          }
        }
        dl {
          display: flex;
          dt {
            flex: 1;
            background: url(../../assets/img/circle-icon.png) no-repeat 5px 0;
            width: 38px;
            max-width: 38px;
            height: 24px;
          }
          dd {
            flex: 1;
            font-size: 14px;
            color: #666;
            span {
              font-size: 12px;
              color: #999;
            }
          }
        }
        &.active {
          dl {
            dt {}
            dd {
              color: #FD3374;
            }
          }
        }
      }
    }
  }
  .righter-container {
    // float: left;
    width: 976px;
    min-width: 976px;
    padding-left: 25px;
    margin-bottom: 25px;
    flex: 1;
    .right-content {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
    }
    .recommend-container {
      .tab-container {
        text-align: right;
        margin-top: 0;
        ul {
          text-align: right;
          li {
            font-size: 14px;
            border: 1px solid #ccc;
            margin: 0;
            width: 68px;
            height: 34px;
            line-height: 34px;
            text-align: center;
            margin-left: -1px;
            color: #666;
            cursor: pointer;
            &.active {
              border: 1px solid #FD3374;
              color: #FD3374;
              position: relative;
              z-index: 1;
              background: #fff;
            }
            &:first-child {
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
            }
            &:last-child {
              border-top-right-radius: 5px;
              border-bottom-right-radius: 5px;
            }
          }
        }
      }
      .list-container {
        margin-top: 20px;
      }
    }
  }
}
.affix {
  position: fixed;
  right: 10%;
  bottom: 20px;
  opacity: 1;
  &.affix-switch {
    opacity: 1;
  }
}
.affix-wrap {
  text-align: center;
  border-radius: 46px;
  width: 46px;
  height: 46px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  background: rgba($color: #000, $alpha: 0.6);
  overflow: hidden;
  &:hover {
    font-weight: bold;
    .affix-icon {
      font-weight: bold;
    }
    & > div:not(:last-child) {
      border-bottom: 2px solid rgba($color: #f20480, $alpha: 0.7);
    }
  }
  .affix-icon {
    font-size: 20px;
  }
  &.iconfont-disable {
    display: none;
  }
  & > div {
    & > p {
      font-size: 12px;
      line-height: 14px;
      position: relative;
      top: -4px;
    }
  }
  & > div:not(:last-child) {
    border-bottom: 2px solid rgba($color: #f20480, $alpha: 0.4);
  }
}
.chapter-switch {
  font-size: 14px;
  margin-top: 20px;
  .chapter-prev {
    float: left;
    cursor: pointer;
    a, a:link, a:active, a:visited {
      color: #157DF9;
    }
  }
  .chapter-next {
    float: right;
    cursor: pointer;
    a, a:link, a:active, a:visited {
      color: #157DF9;
    }
  }
}
.exam-list {
  .c-unfinish {
    color:#FD3374;
    font-style: normal;
  }
  .c-finish {
    color:#21A663;
    font-style: normal;
  }
  a:hover {
    text-decoration: none;
    color: #FD3374;
  }
}
.text-right {
  text-align: right!important;
}
</style>
